'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_AppPageSize() {
}
export { $c_Lapp_api_AppPageSize as $c_Lapp_api_AppPageSize };
$c_Lapp_api_AppPageSize.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_AppPageSize.prototype.constructor = $c_Lapp_api_AppPageSize;
/** @constructor */
function $h_Lapp_api_AppPageSize() {
}
export { $h_Lapp_api_AppPageSize as $h_Lapp_api_AppPageSize };
$h_Lapp_api_AppPageSize.prototype = $c_Lapp_api_AppPageSize.prototype;
$c_Lapp_api_AppPageSize.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
var $d_Lapp_api_AppPageSize = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass(0, "app.api.AppPageSize", ({
  Lapp_api_AppPageSize: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lapp_api_AppPageSize as $d_Lapp_api_AppPageSize };
//# sourceMappingURL=app.api.-App-Page-Size.js.map
